document.addEventListener('DOMContentLoaded', function () {
  console.log('Custom GTM Events');

  const TEXT_NEEDLE = 'virtuelle inspiration';

  const matchesRule = (a) => {
    if (!a || a.tagName !== 'A') return false;
    const href = a.href || '';
    const text = (a.textContent || '').normalize('NFKC').toLowerCase();
    const match = href.startsWith('https://yulio.com/') || text.includes(TEXT_NEEDLE);
    //if (match) console.log('Tracking link:', { href, text });
    return match;
  };

  document.addEventListener('click', function (e) {
    // Only unmodified left-clicks
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const link = e.target.closest('a');
    if (!matchesRule(link)) return;

    e.preventDefault();

    // prevent double handling
    if (link.dataset.vicHandled === '1') return;
    link.dataset.vicHandled = '1';

    const url = link.href;
    const text = (link.textContent || '').trim();

    let navigated = false;
    const navigate = () => {
      if (navigated) return;
      navigated = true;
      // SAME TAB:
      window.location.href = url;
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtual_inspiration_click',
      link_url: url,
      link_text: text,
      eventCallback: navigate,
      eventTimeout: 500
    });

    // Fallback if callback never fires
    setTimeout(navigate, 600);
  }, true); // capture for reliability
});